export default __webpack_public_path__ + "static/media/stfrancisxavier.7f169dbc.jpg";